<template>
  <div class="cooperationView">
    <div class="flex">
      <div style="width: 24px">
        <div class="border-bg">
          <div></div>
        </div>
        <div class="line-bg"></div>
      </div>
      <div class="content-style">
        <div class="title-style">合作关系</div>
        <el-table
          v-loading="scholarCoLoading"
          ref="multipleTable"
          :header-cell-style="{
            background: '#F4F7F9',
            borderBottom: '1px solid #E3EEF5',
            color: '#333333',
            fontSize: '14px',
            fontWeight: '500',
            width: '100%',
          }"
          :data="scholarCoData"
          tooltip-effect="dark"
          style="width: 100%"
        >
          <el-table-column prop="name" label="专家姓名">
            <template slot-scope="scope">
              <div class="person-name">{{ scope.row.name }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="org" label="所属机构">
            <template slot-scope="scope">
              <div class="flex-column overflow overflow-2 person-org">
                {{ scope.row.org }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="honors" label="荣誉头衔">
            <template slot-scope="scope">
              <div class="flex items-center" style="min-height: 46px">
                <div
                  class="flex flex-wrap"
                  v-if="scope.row.honors != null && scope.row.honors.length > 0"
                >
                  <p
                    style="color: #1241C9"
                    v-for="(item, index) in scope.row.honors"
                    :key="index"
                  >
                    <span v-if="index != 0">、</span>
                    {{ item }}
                  </p>
                </div>
                <p v-else>-</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="coType" label="合作方式">
            <template slot-scope="scope">
              <p
                style="color: #f39800"
                class="pre-wrap"
                v-html="scope.row.coType"
              >
                <!-- {{ scope.row.coType }}-->
              </p>
            </template>
          </el-table-column>
          <el-table-column prop="coTimes" label="合作次数">
            <template slot-scope="scope">
              <p
                style="color: #344054; cursor: pointer"
                @click="shouDialog(scope.row)"
              >
                {{ scope.row.coTimes }}次
              </p>
            </template>
          </el-table-column>
        </el-table>
        <div
          class="page-container"
          v-if="scholarCoData && scholarCoData.length"
        >
          <el-pagination
            background
            @current-change="handleCurrentChange"
            :current-page="scholarCoData.pageNo + 1"
            :page-size="scholarCoData.pageSize"
            @size-change="handleSizeChange"
            :page-sizes="[10, 20, 50, 100]"
            layout="sizes,prev, pager, next"
            :total="totalElements"
          />
        </div>
      </div>
    </div>
    <div class="flex">
      <div style="width: 24px">
        <div class="border-bg">
          <div></div>
        </div>
        <div class="line-bg"></div>
      </div>
      <div class="content-style">
        <div class="title-style flex justify-between">
          科研图谱
          <div class="graph-input flex items-center justify-end">
            <el-input
              placeholder="输入人名或者机构名称"
              v-model="graphInput"
              @keyup.enter.native="getScholarRelation"
              style="width: 240px"
            >
              <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
            <div class="city-div">
              <el-cascader
                style="margin-left: 10px; font-size: 16px"
                @change="clickGraphCheckChange"
                v-model="cityValue"
                placeholder="所在地"
                :options="cityList"
                :props="{
                  expandTrigger: 'hover',
                  value: 'regionName',
                  label: 'regionName',
                }"
              ></el-cascader>
            </div>
          </div>
        </div>
        <div></div>
        <div v-loading="graphLoading">
          <div class="flex items-center graph-select justify-end">
            <div class="flex items-center">
              <div class="flex">
                <el-checkbox v-model="showEdge" />
                <p class="select-text">查看合作次数</p>
              </div>
              <p class="select-text" style="font-size: 16px">节点数</p>
              <el-select
                v-model="graphValue"
                placeholder="请选择"
                @change="clickGraphChange"
              >
                <el-option
                  v-for="item in graphOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div
            style="width: 100%; height: 600px; position: relative"
            v-if="graphData != null && graphData.nodes.length > 0"
          >
            <relational-graph
              :graph-data="graphData"
              id="co-author"
              :force="force"
              @graphClick="graphClick"
              :showEdge="showEdge"
            />
          </div>
          <el-empty v-else :height="600" />
        </div>
      </div>
    </div>
    <achievement-dialog
      ref="achievementDialog"
      :scholar-id="scholarId"
      :or-scholar-id="clickId"
    />
  </div>
</template>

<script>
import { getScholarCoInfoApi, getScholarRelationApi } from '@/api/details';
import RelationalGraph from '@/views/details/comps/RelationalGraph.vue';
import AchievementDialog from '@/views/details/comps/achievementDialog.vue';

export default {
  name: 'cooperationView',
  components: { AchievementDialog, RelationalGraph },
  props: ['scholarId'],
  data() {
    return {
      cityList: [
        { regionCode: null, regionName: '全部', type: 'all' },
        { regionCode: null, regionName: '中国', type: 'china' },
      ],
      graphOptions: [
        { label: '10%', value: 0.1 },
        { label: '30%', value: 0.3 },
        { label: '70%', value: 0.7 },
        { label: '100%', value: 1 },
      ],
      graphData: null,
      force: {
        repulsion: 800,
        edgeLength: 220,
        layoutAnimation: false,
      },
      cityValue: '全部',
      graphValue: 0.1,
      graphInput: '',
      showEdge: false,
      totalElements: 10,
      scholarCoLoading: false,
      graphLoading: false,
      scholarParams: {
        pageNo: 0,
        pageSize: 10,
        type: '专家',
      },
      scholarCoData: [],
      clickId: '',
    };
  },
  created() {
    this.getScholarCoInfo();
    this.getScholarRelation();
  },
  methods: {
    shouDialog(item) {
      this.clickId = item.id;
      console.log(this.clickId);
      this.$refs.achievementDialog.showDialog();
    },
    /**
     * 人才触达
     */
    getScholarCoInfo() {
      this.scholarCoLoading = true;
      getScholarCoInfoApi(this.scholarId, this.scholarParams)
        .then((res) => {
          if (res.code == 200) {
            this.totalElements = res.data.totalElements;
            this.scholarCoData = res.data.content;
          }
          this.scholarCoLoading = false;
        })
        .catch(() => {
          this.scholarCoLoading = false;
        });
    },

    /**
     * 科研关系图谱
     */
    getScholarRelation() {
      this.graphLoading = true;
      let param;
      if (this.cityValue === '中国') {
        param = {
          percent: this.graphValue,
          query: this.graphInput,
          province: '中国',
          city: '中国',
        };
      } else {
        param = {
          percent: this.graphValue,
          query: this.graphInput,
        };
      }
      getScholarRelationApi(this.scholarId, param)
        .then((res) => {
          if (res.code == 200) {
            if (
              this.graphValue === 0.1 &&
              (res.data.nodes === null || res.data.nodes.length === 0)
            ) {
              this.graphData = null;
            } else {
              this.graphData = res.data;
            }
          }
          this.graphLoading = false;
        })
        .catch(() => {
          this.graphLoading = false;
        });
    },

    graphClick() {},
    clickGraphChange(val) {
      this.graphValue = val;
      this.getScholarRelation();
    },
    /**
     * 修改国家
     */
    clickGraphCheckChange(val) {
      this.cityValue = val[0];
      this.getScholarRelation();
    },
    /**
     * 修改页数
     * 点击的页数 后台从0开始,所以赋值时-1
     * @param val
     */
    handleCurrentChange(val) {
      this.scholarParams.pageNo = val - 1;
      this.getScholarCoInfo();
    },
    /**
     * 修改单页请求数量
     * 数量
     * @param val
     */
    handleSizeChange(val) {
      this.scholarParams.pageSize = val;
      this.getScholarCoInfo();
    },
  },
};
</script>

<style scoped>
.cooperationView {
  margin: 20px 0;
}

.border-bg {
  width: 24px;
  height: 24px;
  background: #dfedf7;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;

  div {
    width: 12px;
    height: 12px;
    background: #1241C9;
    border-radius: 50%;
  }
}

.line-bg {
  height: calc(100% - 24px);
  width: 4px;
  margin: 0 auto;
  background: #f0f6fb;
}

.content-style {
  width: 100%;
  margin-bottom: 50px;
  margin-left: 20px;

  .title-style {
    text-align: start;
    margin-bottom: 18px;
    font-weight: bold;
    line-height: 24px;
    font-size: 16px;
    color: #333333;
  }
}

.person-name {
  font-size: 15px;
  color: #333333;
}

.person-org {
  font-size: 14px;
  color: #666666;
}

.select-text {
  font-size: 12px;
  margin-right: 10px;
}
</style>
